module.exports = __webpack_public_path__ + "img/w3_cloud_light.775f8f18.png";